import { api } from '../api';
import { useApi } from '../lib/useApi';
import Drawer from '../components/Drawer';
import { ErrorState, Loading } from '../components/ui';
import { ago, fmtDate, n0 } from '../lib/format';
import { useAuth } from '../components/AuthProvider';
import { useAction } from '../lib/useAction';
import { useState } from 'react';

export default function UserDrawer({ id, onClose }) {
  return <Drawer open={!!id} onClose={onClose}>{id ? <Body id={id} onClose={onClose} /> : null}</Drawer>;
}

function Body({ id, onClose }) {
  const { canEdit } = useAuth();
  const { data: u, loading, error, reload } = useApi(() => api.user(id), [id]);

  if (loading) return <div className="dr-body"><Loading what="карточку" /></div>;
  if (error) return <div className="dr-body"><ErrorState error={error} onRetry={reload} /></div>;

  return (
    <>
      <div className="dr-head">
        <button className="close" onClick={onClose} aria-label="закрыть">✕</button>
        <h2>{u.firstName} {u.lastName}</h2>
        <div className="muted" style={{ fontSize: 13 }}>
          {u.email} {u.blocked ? <span className="badge b-blocked">заблокирован</span> : null}
        </div>
      </div>
      <div className="dr-body">
        <dl className="kv">
          <dt>пространства</dt>
          <dd>
            {(u.organizations || []).length
              ? u.organizations.map((r) => (
                  <div key={r.id}>
                    {r.title} — {r.role === 'OWNER' ? 'владелец' : 'редактор'}
                    {r.status === 'PENDING' ? ' (приглашение не принято)' : ''}
                  </div>
                ))
              : <span className="muted">не состоит ни в одном</span>}
          </dd>
          <dt>зарегистрирован</dt><dd>{fmtDate(u.createdAt)}</dd>
          <dt>последняя активность</dt>
          <dd>
            {u.lastActivityAt
              ? <>{fmtDate(u.lastActivityAt)} <span className="muted">({ago(u.lastActivityAt)})</span></>
              : <span className="muted">комментариев не оставлял</span>}
          </dd>
          <dt>комментариев</dt><dd className="mono">{n0(u.comments)}</dd>
          <dt>триал</dt><dd>{u.trialUsedAt ? `использован ${fmtDate(u.trialUsedAt)}` : 'ещё доступен'}</dd>
        </dl>

        {canEdit ? <UserActions user={u} onDone={reload} /> : (
          <div className="note">У вас доступ только на чтение — действия скрыты.</div>
        )}
      </div>
    </>
  );
}

/** Блокировка и сброс триала — существующие админские эндпоинты. */
function UserActions({ user, onDone }) {
  const [reason, setReason] = useState('');
  const trial = useAction(() => api.actions.resetTrial(user.id), { onDone });
  const block = useAction(
    () => (user.blocked ? api.actions.unblockUser(user.id) : api.actions.blockUser(user.id, reason)),
    { onDone });

  return (
    <div>
      <h3 className="dr-h">действия</h3>

      {user.blocked ? null : (
        <label className="field" style={{ maxWidth: 360 }}>
          <span>причина блокировки — её увидит пользователь</span>
          <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="например: спам в комментариях" />
        </label>
      )}

      <div className="act">
        <button className="btn" onClick={() => trial.fire()}>
          {trial.state === 'armed' ? 'точно сбросить?' : trial.state === 'busy' ? 'сбрасываем…'
            : trial.state === 'done' ? 'сброшен' : 'сбросить триал'}
        </button>
        <button
          className="btn danger"
          disabled={!user.blocked && !reason.trim()}
          title={!user.blocked && !reason.trim() ? 'сначала укажите причину' : undefined}
          onClick={() => block.fire()}
        >
          {block.state === 'armed' ? 'точно?' : block.state === 'busy' ? 'применяем…'
            : block.state === 'done' ? 'готово' : user.blocked ? 'разблокировать' : 'заблокировать'}
        </button>
      </div>

      {trial.error || block.error ? (
        <div className="note" style={{ marginTop: 10, borderColor: 'var(--bad)', color: 'var(--bad)' }}>
          {(trial.error || block.error).message}
        </div>
      ) : null}

      <div className="note" style={{ marginTop: 12 }}>
        Сброс триала снова делает человека доступным для бесплатного периода.
        Каждое действие срабатывает со второго нажатия.
      </div>
    </div>
  );
}
